import { render, staticRenderFns } from "./FlexmonsterGenerateData.vue?vue&type=template&id=445a604c&scoped=true&"
import script from "./FlexmonsterGenerateData.vue?vue&type=script&lang=js&"
export * from "./FlexmonsterGenerateData.vue?vue&type=script&lang=js&"
import style0 from "./FlexmonsterGenerateData.vue?vue&type=style&index=0&id=445a604c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a604c",
  null
  
)

export default component.exports